import { Form, Input } from "decorator-form";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import * as displayFragments from "./displayFragments"
import * as actionFragments from "./actionFragments"




const userLayout = FragmentProvider.getLayoutInput({...displayFragments, ...actionFragments});

@Form({title: "Course Details"})
export default class CourseDetailsPanelConfig {

	@Input({type: userLayout, title: "Layout"})
	public userLayout: ILayout<IFragmentLayoutConfig>;
}



// WEBPACK FOOTER //
// ./src/panels/userRegistration/UserRegistrationForm.ts